import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=5716b21e&scoped=true&"
import script from "./SimpleButton.vue?vue&type=script&lang=ts&"
export * from "./SimpleButton.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=5716b21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716b21e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
